export default () => ({
    height: '100%',
    '> .ant-menu': {
        height: '100%',
    },
});
